import React, { useContext, useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import { Grid, Stack } from "@mui/material";
import Img1 from "../../../assets/box1-img.png";
import Img2 from "../../../assets/box2-img.png";
import Img3 from "../../../assets/box3-img.png";
import Img4 from "../../../assets/box4-img.png";
import Img5 from "../../../assets/box5-img.png";
import Img6 from "../../../assets/box6-img.png";
import Img7 from "../../../assets/box7-img.png";
import Img8 from "../../../assets/box8-img.png";
import Img9 from "../../../assets/box9-img.png";
import Img10 from "../../../assets/box10-img.png";
import "../../../styles/Layout/Admin_Styles/_UserDashboard.scss";
import AdminTable from "../AdminTable/AdminTable";
import { authHttp } from "../../services/utility";
import { apisPath } from "../../../utils/path";
import { AuthContext } from "../../../context/AuthContext";

const TableHeadData = [
  {
    id: "date",
    label: "Date of Registrations",
    date: true,
    format: "dd/MM/yyyy",
    alignItems: 'left'
  },
  { id: "total_registrations", label: "Total Registrations", alignItems: 'left' },
  { id: "payment_completed", label: "Completed Application", alignItems: 'left' },
  { id: "total_paid_percentage", label: "Completed Application Percentage", alignItems: 'left' },
];

const UserDashboard = () => {
  const { setIsLoading, setAlertState, setIsTableLoading } =
    useContext(AuthContext);
  const [tableData, setTableData] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [paginationData, setPaginationData] = useState({
    currentPage: 0,
    totalRecord: 20,
    rowsPerPage: 10,
  });

  useEffect(() => {
    setIsLoading(true);
    setIsTableLoading(true);
    getCardsData();
    if (paginationData?.currentPage !== undefined) {
      getTableData(paginationData?.currentPage + 1);
    }
  }, []);

  const getCardsData = () => {
    authHttp
      .get(apisPath?.admin?.dashboardCards)
      .then((res) => {
        setCardData(res?.data?.cardsData);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  const getTableData = (page) => {
    authHttp
      .get(apisPath?.admin?.dashboard + `?page=${page}`)
      .then((res) => {
        setTableData(res?.data?.data);
        setPaginationData((prev) => ({
          ...prev,
          totalRecord: res?.data?.totalCount,
          rowsPerPage: res?.data?.resultperpage,
        }));
        setIsTableLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  const pageChangeHandler = (page) => {
    setIsTableLoading(true);
    getTableData(page + 1);
    setPaginationData((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };

  return (
    <div className="user-dashboard">
      <h2>Dashboard</h2>
      <div className="user-dashboard--wrapper">
        <Grid container spacing={3} marginBottom={"30px"}>
          <Grid item lg={2.4} md={3} sm={4} xs={12}>
            <Paper elevation={3} className="user-dashboard--box">
              <Stack
                direction="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="user-dashboard--box--text">
                  <p>Total Registered</p>
                  <span>
                    {cardData?.total_registered
                      ? cardData?.total_registered
                      : 0}
                  </span>
                </div>
                <div>
                  <img src={Img9} alt="Img" />
                </div>
              </Stack>
            </Paper>
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={12}>
            <Paper elevation={3} className="user-dashboard--box">
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="user-dashboard--box--text">
                  <p>Basic Registration</p>
                  <span>
                    {cardData?.basic_registration
                      ? cardData?.basic_registration
                      : 0}
                  </span>
                </div>
                <div>
                  <img src={Img1} alt="Img" />
                </div>
              </Stack>
            </Paper>
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={12}>
            <Paper elevation={3} className="user-dashboard--box">
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="user-dashboard--box--text">
                  <p>Education</p>
                  <span>
                    {cardData?.education ? cardData?.education : 0}
                  </span>
                </div>
                <div>
                  <img src={Img2} alt="Img" />
                </div>
              </Stack>
            </Paper>
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={12}>
            <Paper elevation={3} className="user-dashboard--box">
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="user-dashboard--box--text">
                  <p>Education+PH/SN</p>
                  <span>
                    {cardData?.education_ph_sn
                      ? cardData?.education_ph_sn
                      : 0}
                  </span>
                </div>
                <div>
                  <img src={Img3} alt="Img" />
                </div>
              </Stack>
            </Paper>
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={12}>
            <Paper elevation={3} className="user-dashboard--box">
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="user-dashboard--box--text">
                  <p>Education+PH/SN+Fee_Exempt</p>
                  <span>
                    {cardData?.education_ph_sn_fee_exempted
                      ? cardData?.education_ph_sn_fee_exempted
                      : 0}
                  </span>
                </div>
                <div>
                  <img src={Img4} alt="Img" />
                </div>
              </Stack>
            </Paper>
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={12}>
            <Paper elevation={3} className="user-dashboard--box">
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="user-dashboard--box--text">
                  <p>Education+PH/SN+Completed</p>
                  <span>
                    {cardData?.education_ph_sn_paid
                      ? cardData?.education_ph_sn_paid
                      : 0}
                  </span>
                </div>
                <div>
                  <img src={Img5} alt="Img" />
                </div>
              </Stack>
            </Paper>
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={12}>
            <Paper elevation={3} className="user-dashboard--box">
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="user-dashboard--box--text">
                  <p>Total Incomplete Application</p>
                  <span>
                    {cardData?.total_unpaid_data
                      ? cardData?.total_unpaid_data
                      : 0}
                  </span>
                </div>
                <div>
                  <img src={Img10} alt="Img" />
                </div>
              </Stack>
            </Paper>
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={12}>
            <Paper elevation={3} className="user-dashboard--box">
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="user-dashboard--box--text">
                  <p>Total Cancelled Application</p>
                  <span>
                    {cardData?.total_cancel_application
                      ? cardData?.total_cancel_application
                      : 0}
                  </span>
                </div>
                <div>
                  <img src={Img6} alt="Img" />
                </div>
              </Stack>
            </Paper>
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={12}>
            <Paper elevation={3} className="user-dashboard--box">
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="user-dashboard--box--text">
                  <p>Total Completed Application</p>
                  <span>
                    {cardData?.total_payments
                      ? cardData?.total_payments
                      : 0}
                  </span>
                </div>
                <div>
                  <img src={Img7} alt="Img" />
                </div>
              </Stack>
            </Paper>
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={12}>
            <Paper elevation={3} className="user-dashboard--box">
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="user-dashboard--box--text">
                  <p>Total Completed Application Percentage</p>
                  <span>
                    {cardData?.total_paid_percentage
                      ? cardData?.total_paid_percentage
                      : 0}
                  </span>
                </div>
                <div>
                  <img src={Img8} alt="Img" />
                </div>
              </Stack>
            </Paper>
          </Grid>
          <Grid item lg={2.4} md={3} sm={4} xs={12}>
            <Paper elevation={3} className="user-dashboard--box">
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="user-dashboard--box--text">
                  <p>Total Admit Card Downloaded</p>
                  <span>
                    {cardData?.admit_card_download
                      ? cardData?.admit_card_download
                      : 0}
                  </span>
                </div>
                <div>
                  <img src={Img7} alt="Img" />
                </div>
              </Stack>
            </Paper>
          </Grid>
        </Grid>
        <div className="user-dashboard--info">
          <div className="user-dashboard--subheading">
            <h3>Manage Registrations</h3>
          </div>
          <div className="user-dashboard--table">
            {/* <AdminTable
              tableHead={TableHeadData}
              pageChangeHandler={pageChangeHandler}
              data={tableData}
              paginationData={paginationData}
            /> */}
            <AdminTable
              tableHead={TableHeadData}
              pageChangeHandler={pageChangeHandler}
              data={tableData}
              paginationData={paginationData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
